import React from 'react';
import { HeroVariant63 } from '../components/HeroVariant63';
import { Services } from '../components/Services';
import { WhyUs } from '../components/WhyUs';
import { FAQ } from '../components/FAQ';
import { Testimonials } from '../components/Testimonials';
import { Consultation } from '../components/Consultation';
import { CookieBanner } from '../components/CookieBanner';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { FloatingContact } from '../components/FloatingContact';
export function LandingPage63() {
  return <div className="min-h-screen w-full" style={{
    backgroundColor: 'var(--bg-primary)'
  }} data-id="element-1762">
      <Navigation data-id="element-1763" />
      <main data-id="element-1764">
        <HeroVariant63 data-id="element-1765" />
        <WhyUs data-id="element-1766" />
        <Services data-id="element-1767" />
        <FAQ data-id="element-1768" />
        <Testimonials data-id="element-1769" />
        <Consultation data-id="element-1770" />
      </main>
      <Footer data-id="element-1771" />
      <CookieBanner data-id="element-1772" />
      <FloatingContact data-id="element-1773" />
    </div>;
}